import { useEffect, useState } from 'react';
import { currentAccount, finishVkLogin, logoutAccount, startVkLogin } from './vk-auth';

let initialAccount: Promise<string | null> | null = null;
function loadAccount() {
  if (!initialAccount) {
    const request=(async () => (await finishVkLogin()) ?? currentAccount())();
    initialAccount=request;
    void request.catch(() => { if (initialAccount===request) initialAccount=null; });
  }
  return initialAccount;
}
export function useAccount() {
  const [userId,setUserId]=useState<string | null>(null);
  const [busy,setBusy]=useState(true);
  const [error,setError]=useState('');
  useEffect(()=>{ let live=true; void (async()=>{
    try { const account=await loadAccount(); if(live)setUserId(account); }
    catch(e){if(live)setError(e instanceof Error ? e.message : 'Не удалось проверить аккаунт.');}
    finally {if(live)setBusy(false);}
  })();
  const retry=()=>{if(!live)return;void loadAccount().then(value=>{if(live){setUserId(value);setError('');}}).catch(()=>{});};
  const expired=()=>{initialAccount=null;setUserId(null);setError('Сеанс истёк. Войдите через VK ID снова.');};
  window.addEventListener('online',retry);window.addEventListener('yumnote:account-expired',expired);
  return ()=>{live=false;window.removeEventListener('online',retry);window.removeEventListener('yumnote:account-expired',expired);}; },[]);
  async function login(){setError('');setBusy(true);try{await startVkLogin();}catch(e){setError(e instanceof Error ? e.message : 'Не удалось начать вход.');setBusy(false);}}
  async function logout(){setError('');setBusy(true);try{await logoutAccount();initialAccount=null;setUserId(null);}catch(e){setError(e instanceof Error ? e.message : 'Не удалось выйти.');}finally{setBusy(false);}}
  return {userId,busy,error,login,logout};
}
